import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { CouponRes } from 'features/coupons/types/coupons.types'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'

export const useFetchCoupon = () => {
	const params = useParams()
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const { data: coupon, isSuccess: isCouponSuccess } = useQuery<CouponRes>({
		queryKey: queryKeys.coupons.detail(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.coupon(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		coupon,
		isCouponSuccess
	}
}
